import { useContext, useState } from "react";
import { useQuery } from "react-query";
import { ModalContext } from "context/ModalContext";
import { Button } from "antd";
import AddProductBenefit from "components/widgets/modals/AddProductBenefit";
import styled from "styled-components";
import Add_Product from "components/widgets/forms/setup/Add_Product";
import { list_commissions } from "services/apiSrv";
import Config from "components/widgets/config"
import { list_intermediary_underwriters } from "services/apiSrv";

// Styled Components
const Container = styled.div`
  padding: 24px;
  max-width: 100%;
  margin: 0 auto;
`;

const DetailsSection = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 32px;
  flex-wrap: wrap;
`;

const DetailsCard = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  flex: 1;
  min-width: 300px;
`;

const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 16px;
  color: #333;
`;

const Subtitle = styled.h2`
  font-size: 20px;
  margin-bottom: 12px;
  color: #555;
`;

function NewProduct(props) {
  const { setModalShow, modalShow, modalClose } = useContext(ModalContext);
  const [items, setItems] = useState([
    { id: 1, name: "Medical Coverage", type: "Health", limit: "50,000" },
    { id: 2, name: "Accident Protection", type: "Liability", limit: "100,000" },
    { id: 3, name: "Travel Insurance", type: "Travel", limit: "20,000" },
    { id: 4, name: "Property Damage", type: "Property", limit: "75,000" },
  ]);

  // Fetch commissions using React Query
  const { data: commissions, isLoading, isError, error } = useQuery({
    queryKey: ["commissions"],
    queryFn: list_commissions,
  });

  // Update items when commissions data is fetched
  if (commissions && items?.length === 0 && !isLoading) {
    setItems(commissions);
  }

  // Handle delete action
  const handleDelete = (id) => {
    setItems(items?.filter((item) => item.id !== id));
  };



  return (
    <Container>
      {/* <Title>Basic Details</Title> */}

      <DetailsSection>
        <DetailsCard>
          <Add_Product />
        </DetailsCard>
      </DetailsSection>

      {/* <Title>Product Configuration</Title>
      <Config />  */}

      {/* <Button
        className="text-white btn-blue rounded float-right mb-3"
        onClick={() => setModalShow(true)}
      >
        Add Benefit
      </Button> */}

      {/* <AddProductBenefit show={modalShow} onHide={modalClose} />
      <Subtitle>Benefits</Subtitle>

      {isLoading && <p>Loading commissions...</p>}
      {isError && <p>Error fetching commissions: {error.message}</p>}

      <div className="card-body pd-0 collapse show" id="customerDetails">
        <div className="table-responsive">
          <table className="table table-hover mg-0">
            <thead className="tx-dark tx-uppercase tx-12 tx-bold">
              <tr className="bg-light">
                <th>Name</th>
                <th>Type</th>
                <th>Limit</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {items?.map((item) => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>{item.type}</td>
                  <td>{item.limit}</td>
                  <td>
                    <Button danger onClick={() => handleDelete(item.id)}>
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div> */}
    </Container>
  );
}

export default NewProduct;